type PostiLangTermMap = {
    [key: string]: string;
}

const postiLangTerms: PostiLangTermMap = {
    postitoimipiste: "App.Posti.Postitoimipiste",
    noutopiste: "App.Posti.Noutopiste",
    postilokero: "App.Posti.Postilokero",
    pakettiautomaatti: "App.Posti.Pakettiautomaatti",
    kirjelaatikko: "App.Posti.Kirjelaatikko",
    yrityspiste: "App.Posti.Yrityspiste"
}

function getPostiLangTerm(term: string): string {
    return postiLangTerms[term]
}

export { getPostiLangTerm }
